<!-- <core-helpers-box-loading *ngIf="status==STATUS_LOADING"></core-helpers-box-loading> -->
<div class="box_default box_white">
    <div *ngIf="status==STATUS_DONE">
        <header>
          <h3>Current user groups</h3>
        </header>
        <!-- END HEADER -->
        <!-- BODY -->
          <ul >
              <core-helpers-lists-one-action-list-item
                  *ngFor="let group of groups | sortBy: 'name' : 'asc' | sortByActive"
                  [title]="group.name"
                  (titleClick)="onSelect(group)"
                  [actionText]="group.active? 'Deactivate' : 'Activate'"
                  (actionClick)="manageActivation(group)"
                  [type]="group.active? '': 'inactive disabled'"
              ></core-helpers-lists-one-action-list-item>
          </ul>
    </div>
    <div class="loader">
      <div class="dimmed" [hidden]="status == STATUS_DONE">
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
          <div class="dimmed_subtitle"></div>
        </div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
          <div class="dimmed_subtitle"></div>
        </div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
          <div class="dimmed_subtitle"></div>
        </div>
        <div class="dimmed_flex">
          <div class="dimmed_box"></div>
          <div class="dimmed_subtitle"></div>
        </div>
      </div>
      <!-- <core-helpers-box-loading [hidden]="status == STATUS_DONE"></core-helpers-box-loading> -->
    </div>
    
</div>
